// 무활동 세션 타임아웃 정책 (시간 단위)
// 관리자(어드민 대행 로그인)와 일반 셀러 모두 12시간으로 통일한다.
export const SESSION_TIMEOUT_HOUR_ADMIN = 12
export const SESSION_TIMEOUT_HOUR_SELLER = 12

// localStorage 의 sessionTime(마지막 요청 시각) 기준으로 무활동 타임아웃 초과 여부 판정
// - sessionTime 이 없으면 만료 아님 (첫 요청)
// - 개발환경 예외: 현재 이 repo 에는 .env.development 가 없고 .env 의 NODE_ENV=staging 이
//   우선하므로 NODE_ENV 가 'development' 가 되는 경우는 없다(= 항상 false).
//   기존 동작 보존을 위해 조건은 유지한다.
export const isSessionExpired = (isAdmin: boolean): boolean => {
  const sessionTime = localStorage.getItem('sessionTime')
  if (!sessionTime) return false
  if (process.env.NODE_ENV === 'development') return false

  const diffTime = new Date().getTime() - Number(sessionTime)
  const diffHour = Math.floor(diffTime / 1000 / 60 / 60)
  const timeoutHour = isAdmin ? SESSION_TIMEOUT_HOUR_ADMIN : SESSION_TIMEOUT_HOUR_SELLER

  return diffHour >= timeoutHour
}
